import { computed } from 'vue';
import { useStore } from 'vuex';

export function useAuthStore() {
  const store = useStore();

  const isAuthenticated = computed(() => {
    const onboardingStatus = store.state.onboarding.status;
    
    if (onboardingStatus === null) {
      const localStatus = localStorage.getItem("authOnboardingStatus");
      return localStatus === "ONBOARDING_COMPLETE";
    }
    
    return store.getters["onboarding/isOnboardingComplete"];
  });

  return {
    isAuthenticated
  };
}
